import { createPaths } from "@routes/utils";

import type { IExtractRouteParamMap } from "@routes";

const baseRoute = `/warehouse-management/central-warehouse-inventory`;

export const centralWarehouseInventoryRoutesObj = {
  list: baseRoute,
  create: `${baseRoute}/create/:warehouseId`,
  edit: `${baseRoute}/edit/:productId`,
  viewItemInventory: `${baseRoute}/view-item-inventory/:productId/:warehouseId`,
  warehouseEntry: `${baseRoute}/warehouse-entry/:productId/:warehouseId`,
  warehouseExit: `${baseRoute}/warehouse-exit/:productId/:warehouseId`,
  sendToScrapWarehouse: `${baseRoute}/send-to-scrap-warehouse/:productId/:warehouseId`,
  returnFromScrapWarehouse: `${baseRoute}/return-from-scrap-warehouse/:productId/:warehouseId`,
  transferToSalesWarehouse: `${baseRoute}/transfer-to-sales-warehouse/:productId/:warehouseId`,
} as const;

export type ICentralWarehouseInventoryRouteParams = IExtractRouteParamMap<
  typeof centralWarehouseInventoryRoutesObj
>;

export const centralWarehouseInventoryPath = createPaths<
  typeof centralWarehouseInventoryRoutesObj,
  ICentralWarehouseInventoryRouteParams
>(centralWarehouseInventoryRoutesObj);
